export const tiposParcela = {
  simplesComAtraso: 1,
  simplesSemAtraso: 2,
  agrupadas: 3,
  agrupadasComAtraso: 4,
};

export const textoTiposParcela = {
  1: "PARCELAS SIMPLES (CLIENTE COM ATRASO)",
  2: "PARCELA SIMPLES (CLIENTE SEM ATRASO)",
  3: "PARCELAS AGRUPADAS (CLIENTE SEM ATRASO)",
  4: "PARCELAS AGRUPADAS (CLIENTE COM ATRASO)",
};
